import {
  IonInfiniteScroll,
  IonInfiniteScrollContent,
} from "@ionic/react";
import Comment from "../Comments";
import { NoRecords } from "../NoRecords";
import { CommentSkeleton } from "../skeletons/CommentSkeleton";
import ErrorToast from "../ErrorToast";

// Level 1 of the comments sheet: the post's comment list. Presentational —
// data + handlers come from usePostComments() in the container. Renders inside
// the sheet's IonContent (so IonInfiniteScroll attaches to that scroll).
const SheetCommentList = ({
  comments,
  hasInitialLoaded,
  error,
  isInfiniteDisabled,
  loadMore,
  onReplyTo,
  lastReply,
  focusCommentId,
  expandForFocus,
  expandForFocusId,
}) => {
  if (error) return <ErrorToast />;

  if (!hasInitialLoaded) {
    return (
      <>
        <CommentSkeleton in_post={true} />
        <CommentSkeleton in_post={true} />
        <CommentSkeleton in_post={true} />
      </>
    );
  }

  if (comments.length === 0) {
    return (
      <div className="ion-padding comments-sheet-empty">
        <NoRecords text="commenti" />
        <p>Sii il primo a commentare!</p>
      </div>
    );
  }

  return (
    <>
      {comments.map((comment) => (
        <Comment
          key={comment.id}
          comment={comment}
          in_post={true}
          classes="ion-padding"
          onReplyTo={onReplyTo}
          lastReply={lastReply}
          focusCommentId={focusCommentId}
          expandForFocus={expandForFocus}
          expandForFocusId={expandForFocusId}
        />
      ))}
      <IonInfiniteScroll
        threshold="100px"
        disabled={isInfiniteDisabled}
        onIonInfinite={loadMore}
      >
        <IonInfiniteScrollContent
          loadingSpinner="bubbles"
          loadingText="Caricando altri commenti..."
        />
      </IonInfiniteScroll>
    </>
  );
};

export default SheetCommentList;
